import React, { useState } from 'react';
import { CheckCircle2, Gauge } from 'lucide-react';

const BenchGallery = ({ images, name, brand }) => {
  const [active, setActive] = useState(0);
  const hasMany = images.length > 1;
  return (
    <div className="relative group">
      <div className="relative overflow-hidden rounded-lg border border-[#2a2a2a] group-hover:border-[#FF6B00] transition-all duration-300">
        <img
          key={active}
          src={images[active]}
          alt={name}
          data-testid="bench-main-image"
          className="w-full h-[420px] md:h-[520px] object-cover animate-in fade-in duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute bottom-6 left-6 flex items-center gap-3">
          <div className="w-12 h-12 bg-[#FF6B00] rounded-lg flex items-center justify-center">
            <Gauge className="text-white" size={24} />
          </div>
          <div>
            <div className="text-white font-bold text-xl">{name}</div>
            <div className="text-gray-300 text-sm">{brand}</div>
          </div>
        </div>
      </div>
      {hasMany && (
        <div className="flex gap-3 mt-4">
          {images.map((src, i) => (
            <button
              key={src}
              type="button"
              onClick={() => setActive(i)}
              data-testid={`bench-thumb-${i}`}
              className={`w-24 h-20 rounded-md overflow-hidden border-2 transition-all duration-300 ${
                i === active ? 'border-[#FF6B00] scale-105' : 'border-[#2a2a2a] opacity-60 hover:opacity-100'
              }`}
            >
              <img src={src} alt={`${name} ${i + 1}`} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const BenchCard = ({ bench, reversed }) => {
  const tests = bench.tests;
  return (
    <div
      data-testid={`bench-card-${bench.id}`}
      className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${reversed ? 'lg:[&>*:first-child]:order-2' : ''}`}
    >
      <BenchGallery images={bench.images} name={bench.name} brand={bench.brand} />

      <div>
        <h3 className="text-3xl font-bold text-white mb-4">{bench.name}</h3>
        <p className="text-gray-400 text-lg mb-8 leading-relaxed">{bench.description}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {tests.map((test, i) => (
            <div key={i} className="flex items-start gap-3 bg-[#1a1a1a] p-4 rounded-lg border border-[#2a2a2a]">
              <CheckCircle2 className="text-[#FF6B00] flex-shrink-0 mt-0.5" size={20} />
              <span className="text-gray-300 text-sm">{test}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BenchCard;
